import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { propBool, propFunc, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import { useDidMount } from '../../../../../../../helpers/use/useHook';
import { useInputBlurOnEnter } from '../../../../../../../helpers/use/useInput';
import InputError from '../../../../../../Ui/Common/InputError';
const FolderNameFormText = (props) => {
    const { className, disabled, input, inputRef, meta, placeholder, wrapOnBlur, } = props;
    const { onBlur: inputOnBlur } = input;
    const onBlur = useCallback((...arg) => {
        inputOnBlur(...arg);
        wrapOnBlur(...arg);
    }, [inputOnBlur, wrapOnBlur]);
    const onKeyDown = useInputBlurOnEnter(inputRef);
    useDidMount(() => {
        inputRef.current.focus();
    });
    return (_jsxs(_Fragment, { children: [_jsx("input", Object.assign({}, input, { autoComplete: 'off', className: clsx('proffit_search_folder_name_input', className), disabled: disabled, name: 'name', onBlur: onBlur, onKeyDown: onKeyDown, placeholder: placeholder, ref: inputRef })), _jsx(InputError, { className: 'proffit_search_folder_name_error', meta: meta })] }));
};
FolderNameFormText.propTypes = {
    className: propStr().isRequired,
    disabled: propBool().isRequired,
    input: propShape().isRequired,
    inputRef: propShape().isRequired,
    meta: propShape().isRequired,
    placeholder: propStr().isRequired,
    wrapOnBlur: propFunc().isRequired,
};
export default FolderNameFormText;
